import style from './03_pricingteachers.css'

import ico1 from '../../Images/money-bag.png'
import ico2 from '../../Images/cash-payment.png'
import ico3 from '../../Images/hundred-points.png'
import ico4 from '../../Images/10815875.png'

export default function PricingTeachers() {
    return (
        <div style={{ backgroundColor: '#FFFDF4' }}>
            <div className='pricingteacherspage-main'>
                <h2>You Teach. You Earn.</h2>
                <p>SurSaathi helps students find the right music teacher—it never stands between you and your income.</p>
                <div className='pricingteacherspage-main-flex'>
                    <div className='pricingteacherspage-main-flex-card'>
                        <img src={ico1} alt="" />
                        <h3>Set Your Own Rates</h3>
                        <span>Charge what your lessons are worth. You're in complete control of your pricing.</span>
                    </div>
                    <div className='pricingteacherspage-main-flex-card'>
                        <img src={ico2} alt="" />
                        <h3>Get Paid Directly</h3>
                        <span>Students pay you directly using the payment method you both prefer.</span>
                    </div>
                    <div className='pricingteacherspage-main-flex-card'>
                        <img src={ico4} alt="" />
                        <h3>Teach Anywhere</h3>
                        <span>Offer online lessons, in-person classes, or a combination of both.</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
